import * as sapper from '@sapper/app';

sapper.start({
  target: document.getElementById('app-container')
});
